import MainLayout from 'layouts/MainLayout.vue'
import LoginPage from 'pages/LoginPage.vue'

const routes = [
  {
    path: '/',
    component: MainLayout,
    children: [
      {
        path: '',
        name: 'home',
        component: () => import('pages/IndexPage.vue'),
        meta: { requiresAuth: true },
      },
      { path: '/executive-dashboard', component: () => import('pages/ExecutiveDashboard.vue') },
      { path: '/executive-summary', component: () => import('pages/ExecutiveSummaryPage.vue') },
      { path: '/ssh-pre-post', component: () => import('src/pages/LiveMocnDashboard.vue') },
      { path: '/daily-kpi', component: () => import('pages/DailyKpiMonitoring.vue') }, // Placeholder
      { path: '/daily-plmn', component: () => import('pages/DailyPlmnMonitoring.vue') },
      { path: '/orion-monitoring', component: () => import('pages/OrionMonitoringPage.vue') },
      { path: '/swe-dashboard', component: () => import('pages/IndexPage.vue') }, // Placeholder
      { path: '/timing-advance', component: () => import('pages/TimingAdvancePage.vue') },
      { path: '/ssh-dashboard', component: () => import('pages/IndexPage.vue') }, // Placeholder
      { path: '/pac-executive', component: () => import('pages/IndexPage.vue') }, // Placeholder
      { path: '/report-generator', component: () => import('pages/ReportGeneratorPage.vue') },
      { path: '/site-references', component: () => import('pages/IndexPage.vue') }, // Placeholder
      { path: '/cell-mapping', component: () => import('pages/IndexPage.vue') }, // Placeholder
      { path: '/export-data', component: () => import('pages/IndexPage.vue') }, // Placeholder
      { path: '/import-data', component: () => import('pages/ImportDataPage.vue') },
      { path: '/data-integrity', component: () => import('pages/DataIntegrityPage.vue') },
      { path: '/chart-testing', component: () => import('pages/ChartTestingPage.vue') },
      { path: '/activity-log', component: () => import('pages/ActivityLogPage.vue') },
      { path: '/options', component: () => import('pages/OptionsPage.vue') }, // Placeholder
      { path: '/settings', component: () => import('pages/SettingsPage.vue') },
      { path: '/vpn-management', component: () => import('pages/VpnManagement.vue') },
    ],
  },
  { path: '/login', name: 'login', component: LoginPage },
  { path: '/:catchAll(.*)*', component: () => import('pages/ErrorNotFound.vue') },
]

export default routes
